import {
    MarketingHeroBanner as MarketingHeroBannerComponent,
    type BannerDataProps,
    type MarketingHeroBannerProps,
    HERO_BANNER_TARGETS,
} from './marketing-hero-banner.react-component';
import {WithCareerAcademiesBanner} from './with-career-academies-banner/with-career-academies-banner.react-component';

const MarketingHeroBanner = WithCareerAcademiesBanner(MarketingHeroBannerComponent);

// Export the final component from index.ts to break circular dependency
export {MarketingHeroBanner, BannerDataProps, MarketingHeroBannerProps, HERO_BANNER_TARGETS};
